var map = {
	"./卷纸.png": "0036",
	"./和牛.png": "53ac",
	"./咖啡机.png": "149f",
	"./大米.png": "0a23",
	"./头盔.png": "7ddb",
	"./打印机.png": "65ca",
	"./打印纸.png": "f100",
	"./排插.png": "e5b2",
	"./探测仪.png": "52a0",
	"./探照灯.png": "4c53",
	"./椰子.png": "c666",
	"./气动扳手.png": "408d",
	"./烧烤箱.png": "ab2a",
	"./电脑.png": "901d",
	"./福利商城-产品图.png": "eb62",
	"./福利商城-左banner图.png": "a5e5",
	"./羽毛球.png": "8289",
	"./螺丝.png": "bc5f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb85";